import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify,{
    directives: {
        Ripple
    }
});

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes:{
            light:{
                primary: colors.blue.darken1,
                secondary: colors.blue.darken3,
                accent: colors.yellow.accent1,
                lighttext: colors.grey.lighten5,
                darktext: colors.grey.darken4,
            },
            dark: true
        }
    }
});
